'use es6';

import { getCurrentInpageMode, getIsDraggingModule } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
const createStateChangeSubscription = (store, selector, onChange) => {
  let currentState;
  const handleChange = () => {
    const nextState = selector(store.getState());
    if (nextState !== currentState) {
      currentState = nextState;
      onChange(currentState);
    }
  };
  // returns an unsubscribe function
  return store.subscribe(handleChange);
};
export const subscribeToSelectedItemIdChanges = (store, onChange) => {
  return createStateChangeSubscription(store, getSelectedItemId, onChange);
};
export const subscribeToInpageModeChanges = (store, onChange) => {
  return createStateChangeSubscription(store, getCurrentInpageMode, onChange);
};
export const subscribeToInpageIsDraggingModuleChanges = (store, onChange) => {
  return createStateChangeSubscription(store, getIsDraggingModule, onChange);
};